import { useState } from 'react';

import Button from 'components/common/Button';
import { TEXT_BOX } from 'lib/constants';

const GraceTextBoxPage = ({ onClick }) => {
  const [text, setText] = useState('');
  const [showError, setShowError] = useState(false);

  const handleSubmit = () => {
    if (!text.trim()) {
      setShowError(true);
      return;
    }

    setShowError(false);
    onClick(text);
  };

  const handleChange = event => {
    setText(event.target.value);

    if (showError && event.target.value.trim()) {
      setShowError(false);
    }
  };

  const styles = () => {
    return `
      w-full
      resize-none
      rounded-md
      border
      bg-white-100
      px-3
      py-3
      font-medium
      text-charcoal-100
      ${showError ? 'border-red-100' : 'border-charcoal-70'}
    `;
  };

  return (
    <section className="px-5">
      <textarea rows={4} value={text} onChange={handleChange} className={styles()} />

      {showError && <p className="text-red-10 mt-1 text-sm">{TEXT_BOX.error}</p>}

      <section className="py-5">
        <Button className="btn btnPrimary w-full" onClick={handleSubmit}>
          {TEXT_BOX.button}
        </Button>
      </section>
    </section>
  );
};

GraceTextBoxPage.propTypes = {
  onClick: PropTypes.func,
};

export default GraceTextBoxPage;
